import React, { useRef } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Page,
  Toolbar,
  ExcelExport,
  PdfExport,
  ColumnChooser,
} from '@syncfusion/ej2-react-grids';
import has from 'lodash/has';
import toString from 'lodash/toString';
import { getFromLocalStorage } from 'localStorageService/LocalStorage';
import { PdfTrueTypeFont } from '@syncfusion/ej2-pdf-export';
import { calibriFont } from 'constant/PdfFont';
// constants
import { dateFormatDDMM } from 'constant/Helpers';
import { localStorageKeys } from 'constant/Enums';

const FloristsPerformanceReportDataGrid = ({ data }) => {
  const toolbarOptions = ['ExcelExport', 'PdfExport', 'CsvExport', 'ColumnChooser', 'Search'];
  const ref = useRef();
  const opsCenter = getFromLocalStorage(localStorageKeys.OPS_CENTER);

  const toolbarClick = (args) => {
    const pdfExportProperties = {
      theme: {
        caption: { font: new PdfTrueTypeFont(calibriFont, 10) },
        header: { font: new PdfTrueTypeFont(calibriFont, 12) },
        record: { font: new PdfTrueTypeFont(calibriFont, 9) },
      },
    };
    switch (args.item.text) {
      case 'PDF Export':
        ref.current.pdfExport(pdfExportProperties);
        break;
      case 'Excel Export':
        ref.current.excelExport();
        break;
      case 'CSV Export':
        ref.current.csvExport();
        break;
      default:
        break;
    }
  };

  const excelQueryCellInfo = (args) => {
    if (has(args.column, 'customExcelTemplate')) {
      args.value = toString(args.column.customExcelTemplate(args.data));
    }
  };

  const dateTemplate = (rowData) => <span>{rowData.date && dateFormatDDMM(rowData.date)}</span>;

  const avergeTimeTemplate = (rowData) => (
    <span>
      {rowData.average != null &&
        !isNaN(rowData.average) &&
        rowData.average.toFixed(opsCenter?.country?.decimalNumber ?? 2)}
    </span>
  );

  return (
    <div className="control-pane">
      <div className="control-section">
        <GridComponent
          dataSource={data}
          allowPaging={true}
          toolbar={toolbarOptions}
          allowExcelExport={true}
          allowPdfExport={true}
          excelQueryCellInfo={excelQueryCellInfo}
          pdfQueryCellInfo={excelQueryCellInfo}
          ref={ref}
          toolbarClick={toolbarClick}
          showColumnChooser={true}
          allowTextWrap={true}
          pageSettings={{ pageSizes: true, pageSize: 20 }}
        >
          <ColumnsDirective>
            <ColumnDirective
              headerText="Date"
              field="date"
              width={120}
              template={dateTemplate}
              customExcelTemplate={(rowData) => rowData.date && dateFormatDDMM(rowData.date)}
              textAlign="Center"
            />
            <ColumnDirective headerText="Florist" field="name" width={120} textAlign="Center" />
            <ColumnDirective headerText="Done" field="done" width={100} textAlign="Center" />
            <ColumnDirective headerText="Not Done" field="notDone" width={100} textAlign="Center" />
            <ColumnDirective
              headerText="Average Preparinng Time"
              field="average"
              template={avergeTimeTemplate}
              width={120}
              customExcelTemplate={(rowData) =>
                rowData.average != null &&
                !isNaN(rowData.average) &&
                rowData.average.toFixed(opsCenter?.country?.decimalNumber ?? 2)
              }
              textAlign="Center"
            />
          </ColumnsDirective>
          <Inject services={[Toolbar, ExcelExport, PdfExport, ColumnChooser, Page]} />
        </GridComponent>
      </div>
    </div>
  );
};

export default React.memo(FloristsPerformanceReportDataGrid);
